import React from 'react';
import { Box, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { IoSearchOutline } from 'react-icons/io5';

interface ISearch {
    value: string;
    setValue: (newValue: string) => void;
    title?: string;
    disabled?: boolean;
}

export const Search = (props: ISearch): JSX.Element => {
    const { value, setValue, title, disabled } = props;

    return (
        <Box w={'sm'} mb={'2'}>
            <InputGroup>
                <InputLeftElement color='gray.400'>
                    <IoSearchOutline />
                </InputLeftElement>
                <Input type='search' placeholder={title || 'Buscar'} value={value}
                    focusBorderColor='primary.400' bg={'white'}
                    variant={'outline'} disabled={disabled}
                    onChange={(e) => setValue(e.target.value)}
                />
            </InputGroup>
        </Box>
    );
};
